/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeleteProposalCommand
 */
export interface DeleteProposalCommand {
    /**
     * 
     * @type {number}
     * @memberof DeleteProposalCommand
     */
    id: number;
}

/**
 * Check if a given object implements the DeleteProposalCommand interface.
 */
export function instanceOfDeleteProposalCommand(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;

    return isInstance;
}

export function DeleteProposalCommandFromJSON(json: any): DeleteProposalCommand {
    return DeleteProposalCommandFromJSONTyped(json, false);
}

export function DeleteProposalCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeleteProposalCommand {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['Id'],
    };
}

export function DeleteProposalCommandToJSON(value?: DeleteProposalCommand | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Id': value.id,
    };
}

